import { API_BASE, PORTAL_ID } from "../utils/api";
import { portalFetchInit } from "../../admin-shared/portalApiAuth";

const authInit = (extra = {}) => portalFetchInit(PORTAL_ID, extra);

export async function fetchStoreLocation() {
  const res = await fetch(
    `${API_BASE}/organization/store-location`,
    authInit({ headers: { "Content-Type": "application/json" } }),
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Failed to load salon location");
  }
  return data.location || null;
}

export async function saveStoreLocation({ latitude, longitude, accuracy }) {
  const res = await fetch(
    `${API_BASE}/organization/store-location`,
    authInit({
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        latitude,
        longitude,
        accuracy,
      }),
    }),
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Failed to save salon location");
  }
  return {
    mode: data.mode || "direct",
    message: data.message || "",
    request: data.request || null,
    location: data.location || null,
  };
}

export async function fetchStoreLocationRequests(status = "pending") {
  const res = await fetch(
    `${API_BASE}/nyafaz-ep/store-location-requests?status=${encodeURIComponent(status)}`,
    authInit(),
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Failed to load location requests");
  }
  return Array.isArray(data.requests) ? data.requests : [];
}

export async function approveStoreLocationRequest(requestId, note = "") {
  const res = await fetch(
    `${API_BASE}/nyafaz-ep/store-location-requests/${requestId}/approve`,
    authInit({
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note }),
    }),
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Failed to approve request");
  }
  return data;
}

export async function rejectStoreLocationRequest(requestId, note = "") {
  const res = await fetch(
    `${API_BASE}/nyafaz-ep/store-location-requests/${requestId}/reject`,
    authInit({
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note }),
    }),
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Failed to reject request");
  }
  return data;
}
